import React from 'react'
import PropTypes from 'prop-types'
import Alert from '../../../atoms/Alert'
import { ALERT_SEVERITY, ALERT_VARIANT } from '../../../../constants'

function ConflictCallout ({ conflict, currentClientName }) {
  if (!conflict || !conflict.existingLinks?.length) return null
  const other = conflict.existingLinks[0]
  const otherName = other.shortName || other.longName || `client #${other.clientId}`
  return (
    <Alert severity={ALERT_SEVERITY.warning} variant={ALERT_VARIANT.standard}>
      This Redtail family is already linked to <strong>{otherName}</strong>.
      You can also link it to <strong>{currentClientName || 'this client'}</strong>.
    </Alert>
  )
}

ConflictCallout.propTypes = {
  conflict: PropTypes.object,
  currentClientName: PropTypes.string
}

export default ConflictCallout
